import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const MapIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.5", ...props.sx}} viewBox="0 0 18 18">
        <path
            d="M17 9C17 13.4183 13.4183 17 9 17M17 9C17 4.58172 13.4183 1 9 1M17 9H1M9 17C4.58172 17 1 13.4183 1 9M9 17C11.001 14.8093 12.1382 11.9664 12.2 9C12.1382 6.03363 11.001 3.19068 9 1M9 17C6.99898 14.8093 5.8618 11.9664 5.8 9C5.8618 6.03363 6.99898 3.19068 9 1M1 9C1 4.58172 4.58172 1 9 1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
